import Input from "components/common/form/inputs/Input";
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { faFilter, faRefresh, faSearch, faSort, faTableList, faXmark, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import Button from "components/common/button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import If from "components/common/If";
import { useSearchParams } from "react-router-dom";
import { isHidden } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";
import {FILER_MODAL_ID, FILTER_QUERY_PARAM} from "./filter/DatalistFilter";
import {SORT_MODAL_ID, SORT_QUERY_PARAM } from "./sort/DatalistSort";

export type DatalistHeaderButtonsType = React.ReactElement | {
    icon: IconDefinition,
    title: string,
    onClick: () => void
    name: string,
    hide?: any | (() => any)
}

type DatalistHeaderPropsType = {
    onSearch: (search: string) => void | Promise<void>,
    name: string
    changeView?: () => void,
    hasSort: boolean,
    hasFilter: boolean,
    onReload: () => Promise<void>
    rightButtons?: DatalistHeaderButtonsType[],
    showChangeView: boolean,
    hideSearchbox: boolean,
    hideRefreshButton: boolean
}

const DatalistHeader = (props: DatalistHeaderPropsType) => {
    const [search, setSearch] = useState('');
    const [t] = useTranslation();
    const [searchParams] = useSearchParams();
    const context = useAppContext();

    const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            props.onSearch(search);
        }
        if (e.key === 'Escape') {
            props.onSearch('');
        }
    }

    const renderSuffix = () => {
        if(!props.rightButtons?.length) return <></>;

        return (
            <>
                {props.rightButtons.filter(x => !('hide' in x) || !isHidden(x.hide)).map(s => {
                    return (
                        'icon' in s ? <Button key={`datalist-header-suffix-${s.name}`} className="h-full" title={s.title} theme="link" onClick={s.onClick}>
                            <FontAwesomeIcon icon={s.icon} />
                        </Button> : s
                    )
                })}
            </>
        )
    }

    return (
        <header className="inline-flex w-full overflow-x-auto">
            <div className="w-full inline-flex">
                <If condition={props.showChangeView}>
                    <Button className="h-full" title="change view" theme="link" onClick={props.changeView}>
                        <FontAwesomeIcon icon={faTableList} />
                    </Button>
                </If>
                <If condition={props.hasFilter}>
                    <Button className="h-full" title="filter" theme={searchParams.get(`${props.name}-${FILTER_QUERY_PARAM}`) ? 'link primary' : 'link'} onClick={() => context.modal.open(`${props.name}-${FILER_MODAL_ID}`)}>
                        <FontAwesomeIcon icon={faFilter} />
                    </Button>
                </If>
                <If condition={props.hasSort}>
                    <Button className="h-full" title="sort" theme={searchParams.get(`${props.name}-${SORT_QUERY_PARAM}`) ? 'link primary' : 'link'} onClick={() => context.modal.open(`${props.name}-${SORT_MODAL_ID}`)}>
                        <FontAwesomeIcon icon={faSort} />
                    </Button>
                </If>
            </div>
            <div className="w-max flex">
                {/*<Button className="h-full" title={t('button.print')} theme="link" onClick={print}>*/}
                {/*    <FontAwesomeIcon icon={faPrint} />*/}
                {/*</Button>*/}
                {renderSuffix()}
                <If condition={!props.hideRefreshButton}>
                    <Button className="h-full" title={t('button.reload')} theme="link" onClick={props.onReload}>
                        <FontAwesomeIcon icon={faRefresh} />
                    </Button>
                </If>
                <If condition={!props.hideSearchbox}>
                    <Input
                        type="search"
                        placeholder={t('common.search')}
                        value={search}
                        wrapperClassName="focus:absolute focus:w-full"
                        onChange={e => setSearch(e || '')}
                        onKeyPress={onKeyPress}
                        suffix={
                            [
                                {
                                    icon: faXmark,
                                    name: `app-datalist-header-search-reset-${props.name}`,
                                    onClick() {
                                        setSearch('');
                                        props.onSearch('');
                                        },
                                    hidden() {
                                        return search.length === 0;
                                        },
                                },
                                {
                                    icon: faSearch,
                                    name: `app-datalist-header-search-submit-${props.name}`,
                                    onClick() {
                                        props.onSearch(search);
                                        },
                                }
                            ]
                        }
                    />
                </If>
            </div>
        </header>
    );
}

export default DatalistHeader;
